<template>
	<div style="background-color: #fff">
		<Header :isHome="false"></Header>
		
		<div class="top-bg" style="padding-top: 6rem;padding-bottom: 2rem;" :style="{backgroundImage:'url('+data.bgImage+')'}" v-if="data">
			<div style="display: flex;flex-direction: column;border-radius: 1rem;width:100%;color: #fff;" class="container">
				<div style="display: flex;align-items: center;">
					<div style="flex: 1;display: flex;align-items: center;">
						<div class="avatar" :style="{backgroundImage:'url('+data.avatar+')'}" style="min-width: 4.5rem;height: 4.5rem;margin-right: 1rem;
						background-repeat: no-repeat;background-size: cover;background-position: center;"></div>
						<div style="display: flex;flex-direction: column;">
							<div style="font-weight: bold;font-size: 2rem;margin-top: -0.5rem;">{{data.title}}</div>
							
							
							<div style="display: flex;align-items: center;margin-top: 0.5rem;">
								<img src="../../assets/imgs/person-icon.png" style="width: 0.8rem;height: 1rem;margin-right: 0.5rem;">
								<div style="margin-right: 1rem;">{{data.followCount}}</div>
								<div style="display: flex;">
									<div :style="{backgroundImage:'url('+avatar+')'}" v-for="(avatar, avatarindex) in data.avatars.slice(0,6)" :key="avatarindex"
											style="width: 1.3rem;height: 1.3rem;border-radius: 50%;margin-left: -0.5rem;background-position: center;background-size: cover;
													background-repeat: no-repeat;border: 1px solid #fff;"></div>
								</div>
							</div>
						</div>
					</div>
					<div style="padding:0.5rem 1rem;border-radius: 5rem;display: flex;align-items: center;justify-content: center;font-weight: bold;cursor: pointer;font-size: 1.2rem;"
							:style="{backgroundColor:data.followed?'transparent':'#31FFDA',border:data.followed?'1px solid #d4f9f3':'1px solid transparent',
										color:data.followed?'#d4f9f3':'#333'}" @click="joincircle()" v-if="!isMobile" v-text="data.followed?'UnJoin':'Join In'"></div>
				</div>
				<div style="font-size: 1rem;margin: 1rem 0 0 5.5rem;color: #EFEFEF;max-width: 44.5rem;">
					{{data.profile}}
				</div>
				<!-- <img src="../../assets/imgs/join.png" style="width: 5rem;height: 2.2rem;"> -->
				<div style="display: flex;align-items: center;margin-top: 1rem;margin-left: 5.5rem;" :style="{justifyContent:isMobile?'space-between':'flex-end'}">
					<div style="display: flex;flex-wrap: wrap;">
						<img src="../../assets/imgs/footer-icon-1.png" style="width: 1.5rem;height: 1.5rem;margin-right: 0.5rem;cursor: pointer;" class="hover-shadow" @click="sharefacebook()">
						<img src="../../assets/imgs/footer-icon-2.png" style="width: 1.5rem;height: 1.5rem;margin-right: 0.5rem;cursor: pointer;" class="hover-shadow" @click="sharetwitter()">
						<!-- <img src="../../assets/imgs/footer-icon-4.png" style="width: 1.5rem;height: 1.5rem;margin-right: 0.5rem;cursor: pointer;" class="hover-shadow"> -->
					</div>
					<div style="padding:0.5rem 1rem;border-radius: 5rem;display: flex;align-items: center;justify-content: center;font-weight: bold;cursor: pointer;font-size: 1.2rem;"
							:style="{backgroundColor:data.followed?'transparent':'#31FFDA',border:data.followed?'1px solid #d4f9f3':'1px solid transparent',
										color:data.followed?'#d4f9f3':'#333'}" @click="joincircle()" v-if="isMobile">{{data.followed?'UnJoin':'Join In'}}</div>
				</div>
			</div>
		</div>
		<div class="container">
			<div class="" style="margin-top: 2rem;font-weight: 500;">
				<span @click="tocirclemain" class="line-title" style="cursor: pointer;">Discussion</span><span style="margin: 0 0.5rem">></span>
				<span>{{data.title}}</span>
			</div>
			<div class="row" style="margin-top: 2rem;margin-bottom: 3rem;">
				
				<div class="col-9 main-box">
					<div style="display: flex;align-items: center;">
						<div class="r-title" style="flex: 1;">
							<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
							<span style="z-index: 1;position: relative;">Recommended Circle</span>
						</div>
					
						<div style="display: flex;align-items: center;">
							<div style="" class="search-box" @keydown.enter="getcommentdata()">
								<input type="text" style="border: none;background-color: transparent;color: #000;font-size: 1rem;width: 100%;" v-model="searchkeyword" placeholder="Search">
								<img src="../../assets/imgs/search-dark.png" style="width: 1rem;height: 1rem;cursor: pointer;" @click="getcommentdata()">
							</div>
						</div>
					</div>
					<div style="margin-top: 1rem;">
						<div style="position: relative;background-color: #fbfbfb;padding: 1rem;">
							<div style="display: flex;align-items: flex-start;">
								<div style="display: flex;align-items: center;position: absolute;">
									
									<div @click="tapsbox = !tapsbox" class="select-tag" ref="tag"># <span v-text="tapitem?tapitem.name:'tag'"></span></div>
												
									<div style="position: absolute;left: 0;top: 2rem;background-color: #fff;font-size: 0.7rem;box-shadow: 0px 2px 30px -10px rgba(0,0,0,0.1);border-radius: 0.2rem;width:11rem;z-index: 11;" v-show="tapsbox">
										<div style="margin-top: 0.5rem;padding: 0.4rem 1rem;cursor: pointer;" @click="clecktag(selecttag)" class="sel-tag" v-for="(selecttag, selectindex) in data.tags">#{{selecttag.name}}
										</div>
									</div>
								</div>
								<textarea cols="30" rows="10" placeholder="add content..." v-model="topiccontent" class="transition-normal"
										:style="{height: img_list.length!=0?'15rem':'10rem',textIndent: (tagwidth+5)+'px'}"
										style="display: flex;align-items: flex-end;width: 100%;height: 10rem;border: none;background-color: transparent;line-height: 2;">
								</textarea>
							</div>
							<div style="position: absolute;left: 1rem;bottom: 1rem;display: flex;width: 94%;flex-direction: column;">
								
								<div style="display: flex;">
									<div v-for="(item,index) in img_list" :key="index" style="position: relative;">
										<div @click="del(index)" style="position: absolute;right: 0.5rem;top: -0.5rem;cursor: pointer;">
											<img src="../../assets/imgs/close-gray.png" style="width: 1rem;height: 1rem">
										</div>
										<img :src="item"  style="width: 4rem;height: 4rem;margin-right: 1rem;"/>
									</div>
								</div>
								
								<div style="display: flex;align-items: center;justify-content: center;margin-top: 1rem;">
									 <div style="flex: 1;display: flex;align-items: center;">
										<div style="display: flex;">
											<form action="" enctype="multipart/form-data">
												<input ref="fileInput" type="file"  multiple="multiple"  accept="image/*" @change="getImg"  id="file"/> 
											</form>
											<div @click="clickFile()"><img src="../../assets/imgs/upload.svg" style="width: 2rem;height: 2rem;margin-right: 1rem;cursor: pointer;"></div>
										</div>
									</div>
									<div style="display: flex;">
										<div style="font-weight: bold;padding: 0.5rem 1rem;align-items: center;justify-content: center;color: #333;border-radius: 2rem;cursor: pointer;" @click="sendmsg()"
													:style="{backgroundColor:topiccontent&&tapitem?'#31ffda':'#e8e8e8'}">
											<img src="../../assets/imgs/send.png" style="width: 1rem;height: 1rem">send
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<div style="" class="tagmenu" ref="wrapper">
						
						<div style="display: flex;align-items: center;margin-top: 2rem;font-weight: 500;font-size: 1rem;cursor: pointer;flex-wrap: nowrap;width: max-content;">
							<div style="margin-right: 1rem;" @click="changetag('', '')" class="line-tag"
									 :class="{'activetag':activetag===''}">ALL</div>
							<div v-for="(tag, index) in data.tags" @click="changetag(tag.id, index)"  class="line-tag"
									style="margin-right: 1rem;" :class="{'activetag':activetag===index}">#{{tag.name}}</div>
						</div>
					</div>
					
					
					<div class="" style="margin: 2rem 0;border: 1px solid #eee;padding: 0rem 1.5rem 1rem;border-radius: 0.5rem;">
						
						
						<div style="display: flex;margin-top: 1rem;cursor: pointer;color: #000;font-weight: 500;width: 100%;border-bottom: 1px solid #eee;padding-bottom: 1rem;"
								:style="{flexDirection:isMobile?'column':'row'}">
							<div style="font-size: 1.5rem;flex: 1;">User Dynamics</div>
							<div style="display: flex;align-items: center;" class="flex-end">
								<div class="btn-normal" :class="{'btn-normal-active':other==0}"  @click="changeother(0)">Latest</div>
								<div class="btn-normal" :class="{'btn-normal-active':other==1}" @click="changeother(1)">Hottest</div>
								<div class="btn-normal" :class="{'btn-normal-active':other==2}" @click="changeother(2)" style="margin-right: 0;">Featured</div>
							</div>
						</div>
						
						<Comment :type="1" :id="id" :other="other" :tagid="tagid" :keyword='searchkeyword' :commentreload="commentreload"></Comment>
					</div>
				</div>
				
				<div class="col-3 r-box" v-if="circledata">
					<div class="r-title">
						<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
						<span style="z-index: 1;position: relative;">Classification</span>
					</div>
					
					<div style="border: 1px solid #eee;padding: 1rem;border-radius: 0.5rem;">
						<div style="font-size: 1.2rem;font-weight: bold;">ALL Topics</div>
						<div style="margin-top: 0.5rem;color: #666;cursor: pointer;" class="line-title"  :style="{fontWeight:item.id == id?'bold':'400',color:item.id == id?'#00E8BE':'#333'}"
								v-for="(item, cirindex) in circledata" :key="cirindex" @click="tocircletopic(item.id)">{{item.title}}</div>
					</div>
					
					
					<div style="border: 1px solid #eee;padding: 1rem;margin-top: 2rem;border-radius: 0.5rem;" v-if="islogin">
						<div style="font-size: 1.2rem;font-weight: bold;">My Topics</div>
						<div style="margin-top: 0.5rem;color: #666;cursor: pointer;" class="line-title"  :style="{fontWeight:item.id == id?'bold':'400',color:item.id == id?'#00E8BE':'#333'}"
								v-for="(item, uindex) in usercircledata" :key="uindex" @click="tocircletopic(item.id)">{{item.title}}</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	
	import axios from 'axios'
	import Header from '/src/components/header.vue'
	import Footer from '/src/components/footer.vue'
	import {baseUrl} from '../../assets/js/public.js'
	// import Pagination from '../../components/pagination.vue'
	import Comment from '/src/components/comment.vue'
	// import BScroll from 'better-scroll'
	import Drag from '../../utils/move.js'
	export default {
		metaInfo() {
			return{
				title: this.data.title, // set a title
				meta: [   // set meta
					{                
						property: 'keyword',
						content: this.data.title
					},
					{                
						property: 'description',
						content: this.data.profile
					},
					{                
						property: 'og:url',
						content: window.location.href
					},
				]
			}
		},
		data() {
			return {
				data:{
					title:'',
					tags:[],
					avatars:[],
					profile:''
				},
				page:1,
				perPage:10,
				colorlist:['#01A587', '#8D66F8', '#ED532B', '#D8BE50', '#52A5F7'],
				
				hotdata:null,
				
				islogin:false,
				headers:{},
				
				id:'',
				activetag: '',
				tagid:'',
				other: 0,
				commentdata:null,
				commentreplyid:'',
				commentreplycontent:'',
				
				circledata:null,
				tapsbox:false,
				// tagsboxid:'',
				
				tapitem:null,
				topiccontent:'',
				
				img_list:[],
				showAdd:true,
				
				usercircledata:null,
				searchkeyword: '',
				isMobile: false,
				commentreload: 0,
				tagwidth:0
			}
		},
		props:{
		},
		components: {
			Header,
			Footer,
			// Pagination,
			Comment
		},
		filters: {
		},
		methods: {
			sharefacebook(){
				window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(window.location.href),'sharer','toolbar=0,status=0,width=626,height=436');
			},
			sharetwitter(){
				let nowurl = encodeURIComponent(window.location.href)
				let url = 'https://twitter.com/intent/tweet?text='+this.data.profile+'&url='+nowurl
				window.open(url)
			},
			tocirclemain(){
				this.$router.push({name:'circlemain'})
			},
			sendmsg(){
				if(this.tapitem&&this.topiccontent){
					let params = {
						content: this.topiccontent,
						circleId: this.id,
						circleTagId: this.tapitem.id,
						images: this.img_list
					}
					this.request({
						method: 'post',
						url: '/gci/circleTopic/add',
						data:params
					}).then(res => {
						this.topiccontent = ''
						this.tapitem = null
						this.img_list = []
						this.commentreload ++
						this.$nextTick(() => {
							this.tagwidth = this.$refs.tag.offsetWidth
						})
						// this.getcommentdata()
						// alert(res.msg)
					}).catch(error => {
						console.error(error.response)
					})
				}else{
					// alert('no taps or no content')
					this.$bus.$emit('message',{
						type:1,
						msg:'no tags or no content'
					})
				}
			},
			clickFile() {
				// const input = document.querySelector('#file')
				// input.click()
				this.$refs.fileInput.dispatchEvent(new MouseEvent('click'))
			},
			getImg(e){
				var file = e.target.files;//这个就是选中文件信息
				let formdata = new FormData()
				Array.from(e.target.files).map(item => {
				 console.log(item)
				 formdata.append("file", item)  //将每一个文件图片都加进formdata
			   })
				axios.post(baseUrl+'/upload', formdata).then(res => { 
					console.log(res) 
					
					this.img_list.push(res.data.data.url);
				})
			},
			del(index){
				this.img_list.splice(index,1)
			},
			clecktag(item){
				this.tapitem = item
				this.tapsbox = false
				this.$nextTick(() => {
					this.tagwidth = this.$refs.tag.offsetWidth
				})
			},
			changeother(i){
				this.other = i
				// this.getcommentdata()
			},
			changetag(id, index){
				// this.page =1
				this.tagid = id
				this.activetag = index
				// this.getcommentdata()
			},
			joincircle(){
				if(this.islogin){
					this.$bus.$emit('noloading', true)
					let params = {
						circleId: this.id
					}
					this.request({
						method: 'post',
						url: '/gci/circle/follow',
						data:params
					}).then(res => {
						if(res.status == 0){
							// this.getdata()
							this.$bus.$emit('message',{
								type:2,
								msg:'successfully'
							})
						}
						this.data.followed = !this.data.followed
					}).catch(error => {
						console.error(error.response)
					})
				}else{
					if(!this.isMobile){
						this.$bus.$emit('login', true)
					}else{
						this.$router.push({name:'mlogin', query:{type:0}})
					}
				}
			},
			getdata(){
				this.request({
					method: 'get',
					url: '/gci/circle/get?circleId='+this.id,
				}).then(res => {
					this.data = res.data
						new Drag(this.$refs.wrapper);
					this.$bus.$emit('loading', false)
				}).catch(error => {
					console.error(error.response)
				})
			},
			getcircledata(){
				this.request({
					method: 'get',
					url: '/gci/circle/list',
				}).then(res => {
					this.circledata = res.data.items
				}).catch(error => {
					console.error(error.response)
				})
			},
			tocircletopic(id){
				this.$router.push({name:'circletopic',query:{id:id}})
				// this.$router.go()
				location.reload();
			},
			getusercircledata(){
				if(this.islogin){
					this.request({
						method: 'get',
						url: '/gci/user/circle/list',
					}).then(res => {
						this.usercircledata = res.data.items
					}).catch(error => {
						console.error(error.response)
					})
				}
			}
		},
		created() {
			this.$bus.$emit('loading', true)
			this.id = this.$route.query.id
		},
		mounted() {
			localStorage.getItem('isMobile') == 'null'?this.isMobile = false:this.isMobile = true
			let token = localStorage.getItem('token')
			if(token){
				this.islogin = true
				this.headers = {authorization:localStorage.getItem('token')}
			}
			this.getdata()
			// this.getcommentdata()
			this.getcircledata()
			this.getusercircledata()
			this.$bus.$emit('totop', true)
			
			this.$nextTick(() => {
				this.tagwidth = this.$refs.tag.offsetWidth
			})
		}
	}
</script>

<style scoped lang="scss">
	#file {
	  display: none;
	}

	.hover-color{color:#333}
	.hover-color-box:hover{
		.hover-color{
			text-decoration: underline;
			color: #00E8BE;
		}
	}
	.sel-tag:hover{
		background-color: #31ffda;
	}
	.avatar{
		background-position: center;background-repeat: no-repeat;background-size: cover;border-radius: 50%;
	}
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			width: 13rem;position: absolute;left: -0.5rem;top: -2rem
		}
	}
	.main-box{
		display: flex;flex-direction: column;
	}
	.title-text{
		margin-left:-2rem
	}
	.title-box{
		display:flex;align-items: center;justify-content: center;font-weight: 900;color: #fff;font-size: 3rem;
	}
	.title-icon{
		width: 3rem;height: 3rem;margin-top: 1rem;
	}
	.top-bg{
		width: 100vw;display: flex;align-items: center;justify-content: center;
		background-size: cover;background-position: center top;background-repeat: no-repeat;
		flex-direction: column;
	}
	
		.comment-reply{
			font-size: 1rem;
		}
		.comment-reply:hover{
			color: #01A587;cursor: pointer;
		}
		.comment-name{
			font-size: 1rem;font-weight: bold;
		}
		.comment-tag{
			font-size: 0.5rem;margin-right: 0.5rem;
		}
		.comment-avatar{
			background-position: center;background-repeat: no-repeat;background-size: cover;
			width: 2.5rem;height: 2.5rem;border-radius: 50%;margin-right: 0.5rem;
		}
		.news-comment-icon{
			width:1rem;height: 1rem;margin-right: 0.5rem;
		}
	.chatbox{
		border: 1px solid #DFDFDF;
		padding: 0.5rem;
		.chatbox-input{
			border: none;
			width:100%
		}
	}
	.search-box{
		width: 13rem;height: 2.5rem;background-color: #fff;border-radius: 5rem;border: 1px solid #eee;padding: 0 1rem;display: flex;align-items: center;
	}
	.line-title:hover{
		color:#62e0c9 !important
	}
	.line-tag:hover{
		// color: #000 !important;
	}
	.line-tag{
		padding: 0.2rem 0.5rem;
		border-radius: 1rem;
	}
	.tagmenu{
		width: 100%;overflow: scroll;
	}
	.tagmenu::-webkit-scrollbar{display: none;}
	.activetag{
		background-color:#31ffda;
		font-weight: bold;
	}
	@media (max-width:767px) {
		.row{
			flex-direction: column;
		}
		.main-box{
			max-width: 100%;
		}
		.r-box{
			max-width:100%
		}
		.top-bg{
			height: 30rem;
		}
		.search-box{
			max-width: 6rem;
			display: none;
		}
		.flex-end{
			justify-content: flex-start;margin-top: 1rem;
		}
	}
</style>